import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  useParams
} from "react-router-dom";
import AdminLogin from './containers/AdminLogin/AdminLogin';
import RootContext from './hoc/RootContext/RootContext';
import SopAssistantTrigger from './components/SopAssistantTrigger/SopAssistantTrigger';
import { PageTitle } from '@project/components';
import CreateNewProfile from './containers/CreateNewProfile/CreateNewProfile';
import SpaceProfile from './containers/SpaceProfile/SpaceProfile';
import Settings from './containers/Settings/Settings';
import RecentProfiles from './containers/RecentProfiles/RecentProfiles'
import { ViewProfile } from './containers/ViewProfile/ViewProfile';
import CompanySettings from './containers/CompanySettings/CompanySettings';
import { IndexPage } from './containers/IndexPage/IndexPage';
import { IntlProvider } from 'react-intl';
import PrivateRouteOutlet from './hoc/PrivateRouteOutlet/PrivateRouteOutlet';
import { RELEASE_VERSION } from '@project/components'
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import English from './lang/en.js';
import Spanish from './lang/es.js';

let locale = navigator.languages.length && navigator.languages[navigator.languages.length - 1];
let lang;
locale = "en"
if (locale === 'en') {
  lang = English;
} else {
  lang = Spanish;
}

console.log(`Rel ${RELEASE_VERSION}`)

// Remounts SpaceProfile whenever the guid route param changes, so switching
// floors can't leave stale state (in-flight saves, dirty flags, debounce
// timers) from the previous floor's profile bleeding into the new one.
function SpaceProfileRoute() {
  const { guid } = useParams();
  return <SpaceProfile key={guid} />;
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/*" element={<PrivateRouteOutlet />}>
        <Route path="profile/edit/:guid" element={<SpaceProfileRoute />} />
        <Route path="profile/new" element={<CreateNewProfile />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profiles/recent" element={<RecentProfiles />} />
        <Route path="company_settings" element={<CompanySettings />} />
      </Route>
      <Route path="/profile/:guid/:privateKey" element={<ViewProfile />} />
      <Route path="/profile/:guid" element={<ViewProfile />} />
      <Route path="/" element={<IndexPage />} />
    </>
  )
)

function App() {
  return (
    <IntlProvider messages={lang} locale={locale} defaultLocale="en">
      <RootContext>
        <PageTitle title="ID360" description="ID360 Space Profiles by ID Plans" />
        <RouterProvider router={router} />
        <SopAssistantTrigger />
        <ToastContainer position="top-right" />
      </RootContext>
    </IntlProvider>
  );
}

export default App;
